import { createCrudSlice } from '../createCrudSlice';
import mainsQuestionsService from '@/services/mainsQuestions.service';

const { reducer, thunks } = createCrudSlice('mainsQuestions', mainsQuestionsService);
export const {
  fetchList: fetchMainsQuestions,
  createItem: createMainsQuestion,
  updateItem: updateMainsQuestion,
  deleteItem: deleteMainsQuestion,
} = thunks;
export default reducer;
